import Repository from "./MapRepository";

const resource = "";
export default {
  /**
   * 河川GeoJson取得
   * @param rvrCd 河川番号
   */
  getRiver(rvrCd) {
    return Repository.get(`${resource}/rvrname/` + rvrCd + `.json`);
  },
  /**
   * 市町村Polygon取得
   * @param townCode 市町村コード
   */
  getTown(townCode) {
    return Repository.get(`${resource}/twn/` + townCode + `.json`);
  },
};
